import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography, Paper, Button, IconButton } from "@mui/material";
import { firestore, storage } from "../../config/firebase.js";
import { useNavigate } from "react-router-dom";
import { Delete, Edit } from "@mui/icons-material";
import Linkify from "react-linkify";
import { Link } from "react-router-dom";
import ImageModal from "../../utils/ImageModal.js";
import { Modal } from "antd";

import { collection, getDocs, deleteDoc, doc, query } from "firebase/firestore";

import moment from "moment";
import AdvertisementModal from "./advertisementModal.js";
import { deleteObject, ref } from "firebase/storage";
const University = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const [selectedPost, setSelectedPost] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const handleEditClick = (post) => {
    setSelectedPost(post);
    setModalOpen(true);
  };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsQuery = query(collection(firestore, "university"));

        const querySnapshot = await getDocs(postsQuery);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPosts(data);
      } catch (error) {
        console.error("Error fetching data from Firebase:", error);
      }
    };

    fetchPosts();
  }, []);

  

  const handleDeleteClick = (post) => {
    setSelectedPostId(post);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirmed = async () => {
  
    try {
      const oldImageRef = ref(storage,selectedPostId?.images);
      deleteObject(oldImageRef).then((r) => {
      });
      await deleteDoc(doc(firestore, "university", selectedPostId?.id));
      setPosts((prevPosts) =>
        prevPosts.filter((post) => post.id !== selectedPostId?.id)
      );
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const handleDeleteCancelled = () => {
    setDeleteModalVisible(false);
  };

  return (
    <div>
      <Modal
        title="Confirm Deletion"
        open={isDeleteModalVisible}
        onOk={handleDeleteConfirmed}
        onCancel={handleDeleteCancelled}
        okText="Yes"
        cancelText="No"
      >
        Are you sure you want to delete this post?
      </Modal>

      <Box className="dashboard">
        <Button
          variant="contained"
          color="primary"
          style={{ marginBottom: "20px", marginTop: "25px" }}
          onClick={() => {
            navigate("/add-university");
          }}
        >
          Add University
        </Button>
        {posts.map((post) => (
          <Paper
            key={post.id}
            elevation={3}
            style={{
              padding: "28px",
              textAlign: "center",
              maxWidth: "600px",
              margin: "20px",
              height: "300px",
              position: "relative",
              borderRadius: "15px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              overflow: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#ccc #f4f4f4",
            }}
          >
            <Typography
              variant="subtitle2"
              style={{
                position: "absolute",
                top: "10px",
                left: "20px",
                color: "#555",
              }}
            >
              {moment(post.timeStamp).format("DD/MMM/YYYY")}
            </Typography>
            <IconButton
              style={{
                position: "absolute",
                top: "10px",
                left: "500px",
                color: "black",
              }}
              onClick={() => handleEditClick(post)}
            >
              <Edit />
            </IconButton>

            <IconButton
              style={{
                position: "absolute",
                top: "10px",
                right: "20px",
                color: "black",
              }}
              color="secondary"
              onClick={() => handleDeleteClick(post)}
            >
              <Delete />
            </IconButton>
            <Typography
              style={{
                marginBottom: "20px",
                marginTop: "10px",
                maxHeight: "150em",
                overflow: "hidden",
                wordWrap: "break-word",
                wordBreak: "break-all",
              }}
              variant="h5"
            >
              {post.title}
            </Typography>

            <Typography
              variant="body1"
              style={{
                maxHeight: "250em",
                overflow: "hidden",
                wordWrap: "break-word",
                wordBreak: "break-all",
              }}
            >
              <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                  <Link to={decoratedHref} target="_blank" key={key}>
                    {decoratedText}
                  </Link>
                )}
              >
                {post.content}
              </Linkify>
            </Typography>

            <img
              src={post.images}
              style={{
                maxWidth: "100%",
                margin: "10px",
                cursor: "pointer",
              }}
              onClick={() => handleImageClick(post.images)}
            />
          </Paper>
        ))}
      </Box>
      <AdvertisementModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        selectedUniversity={selectedPost}
      />
      <ImageModal imageUrl={selectedImage} onClose={handleCloseImageModal} />
    </div>
  );
};

export default University;
